import styled from 'styled-components';

interface StyledAppMobileNavProps {
  $open: boolean;
}

export const StyledAppMobileNav = styled.div<StyledAppMobileNavProps>`
  position: fixed;
  inset: 0;
  z-index: 1000;
  pointer-events: ${(props): string => (props.$open ? 'all' : 'none')};
  visibility: ${(props): string => (props.$open ? 'visible' : 'hidden')};
  transition: visibility 0.25s;

  .mobile-nav__backdrop {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    opacity: ${(props): number => (props.$open ? 1 : 0)};
    transition: opacity 0.25s;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }

  .mobile-nav__panel {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: min(510px, calc(100vw - 40px));
    background: ${(props): string => props.theme.colors.white};
    display: flex;
    flex-direction: column;
    transform: translateX(${(props): string => (props.$open ? '0' : '-100%')});
    transition: transform 0.25s cubic-bezier(0.2, 0, 0, 1);
    overflow: hidden;
  }

  .mobile-nav__header {
    display: flex;
    align-items: center;
    padding: 40px 40px 16px 40px;
    flex-shrink: 0;
  }

  .mobile-nav__header-spacer {
    width: 40px;
    flex-shrink: 0;
  }

  .mobile-nav__logo-link {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  .mobile-nav__logo {
    height: 40px;
    width: auto;
    display: block;

    svg {
      height: 40px;
      width: auto;
    }
  }

  .mobile-nav__close {
    width: 40px;
    height: 40px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &:hover {
      opacity: 0.7;
    }
  }

  .mobile-nav__close-icon {
    width: 40px;
    height: 40px;
    display: flex;
  }

  .mobile-nav__body {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .mobile-nav__item {
    display: flex;
    align-items: center;
    height: 56px;
    padding: 0 40px;
    font-size: 18px;
    font-family: ${(props): string => props.theme.kcc.typography.FONT_FAMILY};
    font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.REGULAR};
    color: ${(props): string => props.theme.kcc.colors.TEXT};
    text-decoration: none;
    flex-shrink: 0;
    transition: background 0.15s;

    &.active {
      font-weight: ${(props): number => props.theme.kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
      text-decoration: underline;
      text-decoration-thickness: 3px;
      text-underline-offset: 3px;
      text-decoration-color: ${(props): string => props.theme.kcc.colors.TEXT};
    }
  }

  .mobile-nav__footer {
    height: 96px;
    background: ${(props): string => props.theme.kcc.colors.BG_LAYOUT};
    padding: 24px 40px 48px;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  .mobile-nav__globe {
    width: 24px;
    height: 24px;
    display: flex;
    flex-shrink: 0;
  }

  .mobile-nav__language {
    font-size: 14px;
    font-family: ${(props): string => props.theme.kcc.typography.FONT_FAMILY};
    color: ${(props): string => props.theme.kcc.colors.TEXT};
  }
`;
